import { LeadCard } from '@marketing-milk/interfaces'
import { useCreateFetchHook, leadCardService } from '@marketing-milk/frontend'

// "100–200 most recent is comfortable" per the bulk lead-card assignment project doc — a hedge
// against a long-tenured client with a decade of immutable forms on their Page, not a response
// to anything observed at normal scale.
const CANDIDATE_CAP = 150

// Fetches one more than the cap so truncation can be detected without a separate count query.
export function useLeadCardCandidates(businessID: number) {
  const result = useCreateFetchHook<LeadCard[]>(
    () => leadCardService.getAll(businessID, CANDIDATE_CAP + 1),
    businessID
  )

  return {
    leadCards: result?.slice(0, CANDIDATE_CAP),
    truncated: (result?.length ?? 0) > CANDIDATE_CAP,
  }
}
